import { Activity } from "lucide-react";
import { DailyChart } from "../pmax/PmaxDaily";

// Day-by-day chart from Social Mirror Campaign Summary add-ons in the current period.
export const SocialMirrorDaily = ({ campaigns = [] }) => {
  const withDaily = campaigns.filter((c) => c.summary?.daily?.length);
  if (!withDaily.length) return null;
  return (
    <div className="space-y-4 mb-6" data-testid="sm-daily">
      {withDaily.map((c) => (
        <div key={c.id} className="bg-white/5 rounded-xl p-5 border border-white/10">
          <p className="flex items-center gap-2 text-white font-semibold mb-3">
            <Activity className="w-4 h-4 text-cyan-300" /> Day by day
            {withDaily.length > 1 && <span className="text-slate-400 text-xs font-normal">{c.location_name || c.campaign_name}</span>}
          </p>
          <DailyChart daily={c.summary.daily} />
        </div>
      ))}
    </div>
  );
};
